/* ==========================================================================
   Pro Shop Ball Database (Complete BC Pro Shop Catalog & Online Presets)
   Contains factory specs & 3D gradient colors for popular bowling balls
   ========================================================================== */

export const PRO_SHOP_BALL_CATALOG = [
  {
    name: "Rubicon UC2",
    brand: "Roto Grip",
    coverType: "Pearl Reactive",
    coverName: "eTrax Pearl Reactive",
    coreType: "Asymmetric",
    coreName: "Rondure Core",
    rg: 2.49,
    diff: 0.052,
    finish: "1500-grit Polished",
    colors: ["#1e293b", "#0d9488", "#94a3b8"]
  },
  {
    name: "Code Red",
    brand: "Storm",
    coverType: "Hybrid Reactive",
    coverName: "R2S Hybrid Reactive",
    coreType: "Asymmetric",
    coreName: "RAD4 Core",
    rg: 2.50,
    diff: 0.058,
    finish: "1500-grit Polished",
    colors: ["#dc2626", "#991b1b", "#0f172a"]
  },
  {
    name: "Sky Rocket",
    brand: "Storm",
    coverType: "Pearl Reactive",
    coverName: "R2S Pearl Reactive",
    coreType: "Symmetric",
    coreName: "Booster Core",
    rg: 2.54,
    diff: 0.046,
    finish: "1500-grit Polished",
    colors: ["#38bdf8", "#0284c7", "#1e293b"]
  },
  {
    name: "Hy-Road Max",
    brand: "Storm",
    coverType: "Solid Reactive",
    coverName: "NeX Solid Reactive",
    coreType: "Symmetric",
    coreName: "Inverted Fe2 Core",
    rg: 2.57,
    diff: 0.046,
    finish: "3000-grit Abralon",
    colors: ["#059669", "#10b981", "#111827"]
  },
  {
    name: "IQ Tour AI",
    brand: "Storm",
    coverType: "Hybrid Reactive",
    coverName: "R2S Hybrid Reactive",
    coreType: "Symmetric",
    coreName: "C3 Centripetal Control Core",
    rg: 2.49,
    diff: 0.029,
    finish: "4000-grit Abralon",
    colors: ["#00a86b", "#000080", "#0f172a"]
  },
  {
    name: "Proton PhysiX",
    brand: "Storm",
    coverType: "Solid Reactive",
    coverName: "NeX Solid Reactive",
    coreType: "Asymmetric",
    coreName: "Atomic Core",
    rg: 2.48,
    diff: 0.053,
    finish: "2000-grit Abralon",
    colors: ["#c71585", "#111111", "#8a2be2"]
  },
  {
    name: "PhysiX",
    brand: "Storm",
    coverType: "Hybrid Reactive",
    coverName: "NRG Hybrid",
    coreType: "Asymmetric",
    coreName: "Atomic Core",
    rg: 2.48,
    diff: 0.053,
    finish: "3000-grit Abralon",
    colors: ["#8b0000", "#ff4500", "#111111"]
  },
  {
    name: "AstroPhysiX",
    brand: "Storm",
    coverType: "Pearl Reactive",
    coverName: "R2S Pearl",
    coreType: "Asymmetric",
    coreName: "Atomic Core",
    rg: 2.48,
    diff: 0.053,
    finish: "1500 Polish",
    colors: ["#000080", "#ff007f", "#4b0082"]
  },
  {
    name: "Infinite PhysiX",
    brand: "Storm",
    coverType: "Pearl Reactive",
    coverName: "Reax Pearl",
    coreType: "Asymmetric",
    coreName: "Atomic Core",
    rg: 2.48,
    diff: 0.053,
    finish: "4000-grit Abralon",
    colors: ["#000000", "#4169e1", "#8a2be2"]
  },
  {
    name: "Summit",
    brand: "Storm",
    coverType: "Solid Reactive",
    coverName: "TX-23 Solid Reactive",
    coreType: "Symmetric",
    coreName: "Centripetal HD A.I. Core",
    rg: 2.46,
    diff: 0.056,
    finish: "3000-grit Abralon",
    colors: ["#005a9c", "#002a4d", "#00a8ff"]
  },
  {
    name: "Summit Peak",
    brand: "Storm",
    coverType: "Pearl Reactive",
    coverName: "TX-23 Pearl",
    coreType: "Symmetric",
    coreName: "Centripetal HD A.I. Core",
    rg: 2.46,
    diff: 0.056,
    finish: "Reacta Gloss",
    colors: ["#ff007f", "#00ffff", "#111111"]
  },
  {
    name: "Absolute",
    brand: "Storm",
    coverType: "Pearl Reactive",
    coverName: "R2S Deep Pearl",
    coreType: "Asymmetric",
    coreName: "Sentinel Core",
    rg: 2.48,
    diff: 0.050,
    finish: "Reacta Gloss",
    colors: ["#ff1493", "#4169e1", "#111111"]
  },
  {
    name: "Absolute Power",
    brand: "Storm",
    coverType: "Solid Reactive",
    coverName: "R2S Solid Reactive",
    coreType: "Asymmetric",
    coreName: "Sentinel Core",
    rg: 2.48,
    diff: 0.050,
    finish: "4000-grit Abralon",
    colors: ["#000080", "#4b0082", "#c0c0c0"]
  },
  {
    name: "DNA Fire",
    brand: "Storm",
    coverType: "Hybrid Reactive",
    coverName: "EXO Hybrid Reactive",
    coreType: "Asymmetric",
    coreName: "Supercoil Core",
    rg: 2.47,
    diff: 0.053,
    finish: "Reacta Gloss",
    colors: ["#ff1493", "#4b0082", "#ffa500"]
  },
  {
    name: "Virtual Energy Blackout",
    brand: "Storm",
    coverType: "Pearl Reactive",
    coverName: "GI-20 Pearl Reactive",
    coreType: "Asymmetric",
    coreName: "Shape-Lock HD Core",
    rg: 2.48,
    diff: 0.052,
    finish: "Reacta Gloss",
    colors: ["#111111", "#222222", "#000000"]
  },
  {
    name: "Phaze II",
    brand: "Storm",
    coverType: "Solid Reactive",
    coverName: "TX-16 Solid Reactive",
    coreType: "Symmetric",
    coreName: "Velocity Core",
    rg: 2.48,
    diff: 0.051,
    finish: "3000-grit Abralon",
    colors: ["#4b0082", "#2d1654", "#111111"]
  },
  {
    name: "Phaze 2 Pearl",
    brand: "Storm",
    coverType: "Pearl Reactive",
    coverName: "TX-25 Pearl",
    coreType: "Symmetric",
    coreName: "Velocity Core",
    rg: 2.48,
    diff: 0.051,
    finish: "Reacta Gloss",
    colors: ["#4b0082", "#50c878", "#c0c0c0"]
  },
  {
    name: "Hy-Road",
    brand: "Storm",
    coverType: "Hybrid Reactive",
    coverName: "R2S Hybrid Reactive",
    coreType: "Symmetric",
    coreName: "Inverted Fe2 Technology",
    rg: 2.57,
    diff: 0.046,
    finish: "1500-grit Polish",
    colors: ["#000000", "#092756", "#2d3135"]
  },
  {
    name: "Hyroad 40",
    brand: "Storm",
    coverType: "Pearl Reactive",
    coverName: "A1S Pearl",
    coreType: "Symmetric",
    coreName: "Inverted Fe2 Core",
    rg: 2.57,
    diff: 0.046,
    finish: "Power Edge",
    colors: ["#008080", "#000080", "#c0c0c0"]
  },
  {
    name: "IQ Tour",
    brand: "Storm",
    coverType: "Solid Reactive",
    coverName: "R2S Solid Reactive",
    coreType: "Symmetric",
    coreName: "C3 Centripetal Control Core",
    rg: 2.49,
    diff: 0.029,
    finish: "4000-grit Abralon",
    colors: ["#000080", "#00004a", "#212529"]
  },
  {
    name: "IQ AI",
    brand: "Storm",
    coverType: "Hybrid Reactive",
    coverName: "R2S Hybrid",
    coreType: "Symmetric",
    coreName: "C3 Centripetal Control Core",
    rg: 2.49,
    diff: 0.029,
    finish: "4000-grit Abralon",
    colors: ["#00a86b", "#000080", "#111111"]
  },
  {
    name: "Ion Pro Max Solid",
    brand: "Storm",
    coverType: "Solid Reactive",
    coverName: "NRG Solid",
    coreType: "Asymmetric",
    coreName: "Element Max A.I. Core",
    rg: 2.49,
    diff: 0.055,
    finish: "2000-grit Abralon",
    colors: ["#007fff", "#008080", "#000080"]
  },
  {
    name: "Tropical Surge",
    brand: "Storm",
    coverType: "Hybrid Reactive",
    coverName: "Reactor Hybrid",
    coreType: "Symmetric",
    coreName: "Surge Core",
    rg: 2.58,
    diff: 0.024,
    finish: "1500-grit Polish",
    colors: ["#ff1493", "#4b0082", "#ffffff"]
  },
  {
    name: "Pitch Black",
    brand: "Storm",
    coverType: "Urethane",
    coverName: "Control Solid Urethane",
    coreType: "Symmetric",
    coreName: "Capacitor Core",
    rg: 2.57,
    diff: 0.022,
    finish: "1000-grit Abralon",
    colors: ["#111111", "#1e1e1e", "#050505"]
  },
  {
    name: "Mix",
    brand: "Storm",
    coverType: "Urethane",
    coverName: "Urethane Solid",
    coreType: "Symmetric",
    coreName: "Pancake Core",
    rg: 2.68,
    diff: 0.006,
    finish: "3500-grit Polish",
    colors: ["#111111", "#ffffff", "#888888"]
  },
  {
    name: "Ice",
    brand: "Storm",
    coverType: "Polyester",
    coverName: "Target Line Polyester",
    coreType: "Symmetric",
    coreName: "Pancake Core",
    rg: 2.71,
    diff: 0.009,
    finish: "High Gloss Polish",
    colors: ["#add8e6", "#ffffff", "#b0c4de"]
  },
  {
    name: "Gem",
    brand: "Roto Grip",
    coverType: "Solid Reactive",
    coverName: "MicroTrax Solid Reactive",
    coreType: "Asymmetric",
    coreName: "Defiant LRG Core",
    rg: 2.47,
    diff: 0.053,
    finish: "2000-grit Abralon",
    colors: ["#00a86b", "#ffd700", "#ff007f"]
  },
  {
    name: "Exotic Gem",
    brand: "Roto Grip",
    coverType: "Pearl Reactive",
    coverName: "MicroTrax Pearl Reactive",
    coreType: "Asymmetric",
    coreName: "Defiant LRG Core",
    rg: 2.47,
    diff: 0.053,
    finish: "1500-grit Polish",
    colors: ["#dda0dd", "#4b0082", "#ffd700"]
  },
  {
    name: "Optimum Stealth",
    brand: "Roto Grip",
    coverType: "Solid Reactive",
    coverName: "MicroTrax Solid Reactive",
    coreType: "Symmetric",
    coreName: "Sure D7 Symmetric Core",
    rg: 2.48,
    diff: 0.048,
    finish: "2000-grit Abralon",
    colors: ["#2b2b2b", "#121212", "#00bcd4"]
  },
  {
    name: "Optimum Cell",
    brand: "Roto Grip",
    coverType: "Solid Reactive",
    coverName: "AWT Solid",
    coreType: "Asymmetric",
    coreName: "Nucleus Core",
    rg: 2.52,
    diff: 0.056,
    finish: "2000-grit Abralon",
    colors: ["#ff5722", "#4a148c", "#111111"]
  },
  {
    name: "Attention Star",
    brand: "Roto Grip",
    coverType: "Pearl Reactive",
    coverName: "eTrax Pearl",
    coreType: "Asymmetric",
    coreName: "Momentum A.I. Core",
    rg: 2.49,
    diff: 0.050,
    finish: "1500-grit Polish",
    colors: ["#00f2fe", "#4facfe", "#111111"]
  },
  {
    name: "RST Hyperdrive",
    brand: "Roto Grip",
    coverType: "Solid Reactive",
    coverName: "MicroTrax Solid",
    coreType: "Asymmetric",
    coreName: "RST A.I. Core",
    rg: 2.53,
    diff: 0.053,
    finish: "2000-grit Abralon",
    colors: ["#4b0082", "#ff00ff", "#000080"]
  },
  {
    name: "Hustle RIP",
    brand: "Roto Grip",
    coverType: "Solid Reactive",
    coverName: "VTC Solid Reactive",
    coreType: "Symmetric",
    coreName: "Hustle Core",
    rg: 2.53,
    diff: 0.030,
    finish: "3000-grit Abralon",
    colors: ["#000080", "#4682b4", "#111111"]
  },
  {
    name: "Harsh Reality",
    brand: "900 Global",
    coverType: "Solid Reactive",
    coverName: "Reserve Blend 902 Solid",
    coreType: "Asymmetric",
    coreName: "Disturbance Asymmetric A.I. Core",
    rg: 2.48,
    diff: 0.054,
    finish: "2000-grit Abralon",
    colors: ["#4a148c", "#b71c1c", "#111111"]
  },
  {
    name: "Sublime",
    brand: "900 Global",
    coverType: "Hybrid Reactive",
    coverName: "Reserve Blend 802 Hybrid",
    coreType: "Symmetric",
    coreName: "Immersive Symmetric A.I. Core",
    rg: 2.47,
    diff: 0.056,
    finish: "1500-grit Polish",
    colors: ["#50c878", "#0080ff", "#ffffff"]
  },
  {
    name: "Zen Gold Label",
    brand: "900 Global",
    coverType: "Pearl Reactive",
    coverName: "Reserve Blend 801 Pearl",
    coreType: "Symmetric",
    coreName: "Meditate Symmetric Core",
    rg: 2.49,
    diff: 0.051,
    finish: "1500-grit Polish",
    colors: ["#ffd700", "#ffffff", "#b87333"]
  },
  {
    name: "Zen U",
    brand: "900 Global",
    coverType: "Urethane",
    coverName: "S77+ Solid Urethane",
    coreType: "Symmetric",
    coreName: "Meditate Symmetric Core",
    rg: 2.49,
    diff: 0.051,
    finish: "1000-grit Abralon",
    colors: ["#000080", "#111111", "#ffffff"]
  },
  {
    name: "Origin EX",
    brand: "900 Global",
    coverType: "Solid Reactive",
    coverName: "RB 89 Solid",
    coreType: "Asymmetric",
    coreName: "Ellipse Asymmetric A.I. Core",
    rg: 2.48,
    diff: 0.051,
    finish: "2000-grit Abralon",
    colors: ["#ff5722", "#b71c1c", "#4a148c"]
  },
  {
    name: "Black Widow 3.0",
    brand: "Hammer",
    coverType: "Solid Reactive",
    coverName: "HK22 - Aggression Solid",
    coreType: "Asymmetric",
    coreName: "Gas Mask",
    rg: 2.50,
    diff: 0.058,
    finish: "2000-grit Abralon",
    colors: ["#b71c1c", "#111111", "#d32f2f"]
  },
  {
    name: "Black Widow 2.0 Hybrid",
    brand: "Hammer",
    coverType: "Hybrid Reactive",
    coverName: "HK22 - Aggression Hybrid",
    coreType: "Asymmetric",
    coreName: "Gas Mask",
    rg: 2.50,
    diff: 0.058,
    finish: "1500-grit Polish",
    colors: ["#ff4500", "#111111", "#ff8c00"]
  },
  {
    name: "Effect",
    brand: "Hammer",
    coverType: "Pearl Reactive",
    coverName: "HK22 - Cohesion Pearl",
    coreType: "Asymmetric",
    coreName: "Huntsman Core",
    rg: 2.47,
    diff: 0.050,
    finish: "1500-grit Polish",
    colors: ["#4a148c", "#00bcd4", "#ff007f"]
  },
  {
    name: "Raw Hammer Solid",
    brand: "Hammer",
    coverType: "Solid Reactive",
    coverName: "Juiced Solid",
    coreType: "Symmetric",
    coreName: "Raw Hammer Symmetrical Core",
    rg: 2.53,
    diff: 0.038,
    finish: "3000-grit Abralon",
    colors: ["#ff4500", "#111111", "#ff0000"]
  },
  {
    name: "Scorpion Low Flare",
    brand: "Hammer",
    coverType: "Solid Reactive",
    coverName: "Semtex Active Solid",
    coreType: "Symmetric",
    coreName: "LED 3.0 Low Flare",
    rg: 2.47,
    diff: 0.031,
    finish: "2000-grit Abralon",
    colors: ["#e65100", "#111111", "#37474f"]
  },
  {
    name: "Mindset",
    brand: "Brunswick",
    coverType: "Solid Reactive",
    coverName: "Evolution Reactive Solid",
    coreType: "Asymmetric",
    coreName: "Mindset Core",
    rg: 2.48,
    diff: 0.050,
    finish: "2000-grit Abralon",
    colors: ["#ff6f00", "#111111", "#0d47a1"]
  },
  {
    name: "Perfect Mindset",
    brand: "Brunswick",
    coverType: "Hybrid Reactive",
    coverName: "Evolution Hybrid Reactive",
    coreType: "Asymmetric",
    coreName: "Mindset Core",
    rg: 2.48,
    diff: 0.050,
    finish: "1500-grit Polish",
    colors: ["#0d47a1", "#ff1493", "#ffd700"]
  },
  {
    name: "Rhino",
    brand: "Brunswick",
    coverType: "Pearl Reactive",
    coverName: "R-16 Pearl Reactive",
    coreType: "Symmetric",
    coreName: "Light Bulb Core",
    rg: 2.62,
    diff: 0.030,
    finish: "500-grit / Polish",
    colors: ["#ff00ff", "#00ffff", "#ffffff"]
  },
  {
    name: "Jackal Ambush",
    brand: "Motiv",
    coverType: "Solid Reactive",
    coverName: "Coercion HV3 Solid",
    coreType: "Asymmetric",
    coreName: "Predator V2 Core",
    rg: 2.47,
    diff: 0.054,
    finish: "2000-grit LSS",
    colors: ["#00f2fe", "#111111", "#ffb703"]
  },
  {
    name: "Venom Shock",
    brand: "Motiv",
    coverType: "Solid Reactive",
    coverName: "Turmoil MFV Solid",
    coreType: "Symmetric",
    coreName: "Gear Core",
    rg: 2.48,
    diff: 0.034,
    finish: "4000-grit LSS",
    colors: ["#8a2be2", "#000000", "#ff007f"]
  },
  {
    name: "Tundra Fire",
    brand: "Track",
    coverType: "Pearl Reactive",
    coverName: "HK22 - DR-5 Pearl",
    coreType: "Symmetric",
    coreName: "Track Symmetric Core",
    rg: 2.56,
    diff: 0.030,
    finish: "1500-grit Polish",
    colors: ["#00bcd4", "#4682b4", "#ffffff"]
  }
];

